import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SideBar from '../../Components/Partials/SideBar';
import Navbar from '../../Components/Partials/Navbar';
import Footer from '../../Components/Partials/Footer';

const Wrapper = ({ page_content }) => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const mq = window.matchMedia('(max-width: 1023.98px)');
        const apply = () => setSidebarOpen(!mq.matches);
        apply();

        const handler = () => apply();
        if (mq.addEventListener) mq.addEventListener('change', handler);
        else mq.addListener(handler);
        return () => {
            if (mq.removeEventListener) mq.removeEventListener('change', handler);
            else mq.removeListener(handler);
        };
    }, []);

    // Auto-close sidebar drawer on navigation for mobile screens (<1024px)
    useEffect(() => {
        if (typeof window !== 'undefined' && window.innerWidth < 1024) {
            setSidebarOpen(false);
        }
    }, [location.pathname]);

    const toggleSidebar = () => setSidebarOpen((v) => !v);
    const closeSidebar = () => setSidebarOpen(false);

    return (
        <div
            className="h-screen overflow-hidden flex"
            style={{
                background: 'var(--color-bg, #F8FAFC)',
                transition: 'background 0.2s ease',
            }}
        >
            <div
                className={`ddwoms-sidebar-backdrop${sidebarOpen ? ' is-open' : ''}`}
                onClick={closeSidebar}
                aria-hidden="true"
            />

            <SideBar isOpen={sidebarOpen} onClose={closeSidebar} />

            <div className={`ddwoms-main${sidebarOpen ? '' : ' sidebar-collapsed'}`}>
                <Navbar onToggleSidebar={toggleSidebar} />

                {/* Scrollable page content */}
                <main className="flex-1 overflow-y-auto overflow-x-hidden p-3 sm:p-5 lg:p-6 max-w-full">
                    {page_content}
                </main>

                <Footer />
            </div>
        </div>
    );
};

export default Wrapper;
